import { API_ENDPOINT } from '../../constants';

export const FIELD_TEMPLATES_API_BASE = `${API_ENDPOINT}/field_templates`;
